/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiAnalyticEventPipMoveFromJSON(json) {
    return StreemApiAnalyticEventPipMoveFromJSONTyped(json, false);
}
export function StreemApiAnalyticEventPipMoveFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'user': !exists(json, 'user') ? undefined : json['user'],
        'start': !exists(json, 'start') ? undefined : json['start'],
        'stop': !exists(json, 'stop') ? undefined : json['stop'],
    };
}
export function StreemApiAnalyticEventPipMoveToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'user': value.user,
        'start': value.start,
        'stop': value.stop,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiAnalyticEventPipMoveUser;
(function (StreemApiAnalyticEventPipMoveUser) {
    StreemApiAnalyticEventPipMoveUser["LOCAL"] = "PIP_USER_TYPE_LOCAL";
    StreemApiAnalyticEventPipMoveUser["REMOTE"] = "PIP_USER_TYPE_REMOTE";
    StreemApiAnalyticEventPipMoveUser["INVALID"] = "PIP_USER_TYPE_INVALID";
})(StreemApiAnalyticEventPipMoveUser || (StreemApiAnalyticEventPipMoveUser = {}));
/**
* @export
* @enum {string}
*/
export var StreemApiAnalyticEventPipMoveStart;
(function (StreemApiAnalyticEventPipMoveStart) {
    StreemApiAnalyticEventPipMoveStart["BOTTOMLEFT"] = "PIP_POSITION_BOTTOM_LEFT";
    StreemApiAnalyticEventPipMoveStart["BOTTOMRIGHT"] = "PIP_POSITION_BOTTOM_RIGHT";
    StreemApiAnalyticEventPipMoveStart["INVALID"] = "PIP_POSITION_INVALID";
    StreemApiAnalyticEventPipMoveStart["TOPLEFT"] = "PIP_POSITION_TOP_LEFT";
    StreemApiAnalyticEventPipMoveStart["TOPRIGHT"] = "PIP_POSITION_TOP_RIGHT";
})(StreemApiAnalyticEventPipMoveStart || (StreemApiAnalyticEventPipMoveStart = {}));
/**
* @export
* @enum {string}
*/
export var StreemApiAnalyticEventPipMoveStop;
(function (StreemApiAnalyticEventPipMoveStop) {
    StreemApiAnalyticEventPipMoveStop["BOTTOMLEFT"] = "PIP_POSITION_BOTTOM_LEFT";
    StreemApiAnalyticEventPipMoveStop["BOTTOMRIGHT"] = "PIP_POSITION_BOTTOM_RIGHT";
    StreemApiAnalyticEventPipMoveStop["INVALID"] = "PIP_POSITION_INVALID";
    StreemApiAnalyticEventPipMoveStop["TOPLEFT"] = "PIP_POSITION_TOP_LEFT";
    StreemApiAnalyticEventPipMoveStop["TOPRIGHT"] = "PIP_POSITION_TOP_RIGHT";
})(StreemApiAnalyticEventPipMoveStop || (StreemApiAnalyticEventPipMoveStop = {}));
//# sourceMappingURL=StreemApiAnalyticEventPipMove.js.map